import React from 'react';
import styled from 'styled-components';
import bg from "../assets/footer.webp";
import logo from "../assets/acarpenlogo3.png"
const FooterContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-evenly;
  align-items: flex-start;
  font-family: Poppins;
  width: 100%;
  height: auto;
  padding: 40px;
  background-image: url(${bg});
  background-size: cover;
  background-position: bottom;
  color: white;

  @media (max-width: 768px) {
    flex-direction: column;
    align-items: center;
    text-align: center;
    padding: 20px;
  }
`;

const LeftSection = styled.div`
  padding: 40px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;

  @media (max-width: 768px) {
    padding: 20px;
    align-items: center;
  }
`;

const Title = styled.h2`
  font-size: 2.5rem;
  font-weight: bold;
  color: white;

  @media (max-width: 768px) {
    font-size: 2rem;
  }
`;

const Subtitle = styled.p`
  font-size: 1rem;
  letter-spacing: 1px;
  color: #ffffff;

  @media (max-width: 768px) {
    font-size: 0.9rem;
  }
`;

const ContactButton = styled.button`
  padding: 10px 20px;
  font-size: 1rem;
  color: white;
  background-color: transparent;
  border: 2px solid white;
  border-radius: 5px;
  cursor: pointer;
  margin-top: 20px;

  &:hover {
    background-color: white;
    color: #d32f2f;
  }

  @media (max-width: 768px) {
    font-size: 0.9rem;
    padding: 8px 16px;
  }
`;

const RightSection = styled.div`
  padding: 40px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;

  @media (max-width: 768px) {
    padding: 20px;
    align-items: center;
  }
`;

const Menu = styled.div`
  margin-bottom: 30px;

  @media (max-width: 768px) {
    margin-bottom: 20px;
  }
`;

const MenuItem = styled.a`
  color: #ffffff;
  font-size: 1rem;
  margin: 5px 0;
  text-decoration: none;
  display: block;

  &:hover {
    color: #ffffff;
  }

  @media (max-width: 768px) {
    font-size: 0.9rem;
  }
`;

const ContactInfo = styled.div`
  color: #ffffff;
  font-size: 1rem;
  line-height: 1.5;

  @media (max-width: 768px) {
    font-size: 0.9rem;
    text-align: center;
  }
`;

const Copyright = styled.p`
  font-size: 0.8rem;
  color: #707070;
  margin-top: 20px;

  @media (max-width: 768px) {
    font-size: 0.7rem;
  }
`;

const Footer = () => {
  return (
    <FooterContainer>
      <LeftSection>
        <img src={logo} style={{width:"150px",marginBottom:"30px"}} />
        <Subtitle>KALİTELİ ÜRÜNLERLE</Subtitle>
        <Title>En iyi hizmet için</Title>
        <ContactButton>BİZE ULAŞIN</ContactButton>
      </LeftSection>
      <RightSection>
        <Menu>
          <h3 style={{marginBottom:"10px"}}>Hizmetler</h3>
          <MenuItem href="#">Cam Balkon</MenuItem>
          <MenuItem href="#">Duşakabin</MenuItem>
          <MenuItem href="#">Panjur</MenuItem>
          <MenuItem href="#">Sineklik</MenuItem>
          <MenuItem href="#">PVC Kapı</MenuItem>
          <MenuItem href="#">PVC Pencere</MenuItem>
        </Menu>
      </RightSection>
      <RightSection>
        <ContactInfo>
          <h3 style={{marginBottom:"10px"}}>İletişim</h3>
          <p>Bağarası sanayi Sitesi no 7</p>
          <p>Söke / AYDIN</p>
          <p>0545 936 74 80</p>
          <p>aokan2617@gmail.com</p>
        </ContactInfo>
        <Copyright>Copyright © 2024 ACAR PEN.</Copyright>
      </RightSection>
    </FooterContainer>
  );
};

export default Footer;
